import { urlBaseEdukando } from "../../config";
import { get } from "./axiosServices";

const urlUserEdukando = `${urlBaseEdukando}core_user_get_users&moodlewsrestformat=json&criteria[0][key]=email&criteria[0][value]=`;
const urlProgressEdukando = `${urlBaseEdukando}core_enrol_get_users_courses&moodlewsrestformat=json&userid=`;
const urlIntegrationNews = `${urlBaseEdukando}local_news_get_news&moodlewsrestformat=json`;

export const getUserProgress = async (email) => {
  try {
    let result = 0;
    const data = await get(`${urlUserEdukando}${email}`);
    if (data && data.users && data.users.length) {
      const userid = data.users[0].id;
      const dataProgress = await get(`${urlProgressEdukando}${userid}`);
      if (dataProgress && dataProgress.length) {
        let suma = 0;
        dataProgress.forEach((element) => {
          if (element.progress) {
            suma = suma + element.progress;
          }
        });
        result = (suma / dataProgress.length).toFixed(0);
      }
    }
    return result;
  } catch (error) {
    return 0;
  }
};

export const getNews = async () => {
  try {
    const data = await get(urlIntegrationNews);
    if (data && data.length) {
      return data;
    } else {
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};
